import React from "react";
import { makeStyles, Typography, Grid, Box } from "@material-ui/core";

import { TextInput, Icon, UploadButton, AddressAutoComplete } from "../../../../../components/base";
import CountryCodePicker from "../../../../../components/countryCodePicker";
import { COLORS } from "../../../../../theme/colors";
import { validateEmail } from "../../../../../services/utils";

import user from "../../../../../assets/images/icons/user.svg";
import email from "../../../../../assets/images/icons/email.svg";

export const useStyles = makeStyles(() => ({
  inputContainer: {
    marginTop: 30,
    display: "flex",
    justifyContent: "space-between",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: COLORS.darks[0][6],
    border: `1px solid ${COLORS.darks[0][25]}`,
    height: 36,
    width: 110,
  },
  logoMain: {
    display: "flex",
    alignItems: "center",
  },
  labelRoot: {
    color: COLORS.darks[0][50],
  },
  logoLabel: {
    color: COLORS.darks[0][50],
  },
  addressText: {
    fontSize: 14,
    width: "100%",
    height: 40,
    lineHeight: 3,
    borderRadius: 4,
    display: "block",
    backgroundColor: "white",
    boxSizing: "border-box",
    padding: "11.5px 14px",
    border: `1px solid ${COLORS.darks[0][25]}`,
    "&:focus-visible": {
      outline: `2px solid ${COLORS.purple}`,
      border: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "11.5px 14px",
    },
  },
}));

const CompanyDetails = ({
  uploadImage,
  uploading,
  handleInputsChange,
  setSelectedAddress,
  companyData,
  updateCompanyDetails,
  setErrors,
  errors,
}) => {
  const classes = useStyles();
  return (
    <Grid xs={4}>
      <TextInput
        id="companyname-input"
        fullWidth
        label="Company name"
        value={companyData?.name}
        labelRoot={classes.labelRoot}
        onChange={(e) => handleInputsChange("name", e)}
        onBlur={() => {
          const errors = {};
          if (!companyData?.name) {
            errors["name"] = "Company name should not be empty";
          }
          setErrors(errors);
          if (Object.keys(errors).length > 0) {
            return;
          }
          updateCompanyDetails("name", companyData.name);
        }}
        error={errors.name}
        onFocus={() => setErrors({ ...errors, name: null })}
      />
      <Box>
        <Typography className={classes.labelRoot}>Company address</Typography>
        <AddressAutoComplete
          onSeleted={(e) => {
            const address = e?.formatted_address;
            updateCompanyDetails("address", e?.formatted_address);
            setSelectedAddress(address);
          }}
          value={companyData?.company_address}
          onChange={(e) => {
            handleInputsChange("company_address", e);
          }}
          cssStyle={classes.addressText}
        />
      </Box>
      <CountryCodePicker
        label="Phone number"
        name="company_phone"
        type="number"
        fullWidth
        labelRoot={classes.labelRoot}
        id="number-input"
        placeHolder="Phone Number"
        value={companyData?.company_phone}
        countryCode={companyData?.company_phone_code ? companyData?.company_phone_code : "+1"}
        onChange={(e) => {
          handleInputsChange("company_phone", e);
        }}
        error={errors.phone_number}
        onFocus={() => setErrors({ ...errors, phone_number: null })}
        onBlur={(name, phone) => {
          updateCompanyDetails(name, phone);
        }}
        setErrors={setErrors}
      />
      <TextInput
        id="Contact-input"
        fullWidth
        placeHolder="name"
        label="Contact person"
        startAdornment={<img src={user} alt="lock-icon" />}
        value={companyData?.contact_person_username}
        labelRoot={classes.labelRoot}
        onChange={(e) => handleInputsChange("contact_person_username", e)}
        onBlur={() => {
          updateCompanyDetails("contact_person_username", companyData?.contact_person_username);
        }}
        error={errors.user_name}
        onFocus={() => setErrors({ ...errors, user_name: null })}
      />
      <TextInput
        id="email-input"
        fullWidth
        placeHolder="email"
        startAdornment={<img src={email} alt="lock-icon" />}
        value={companyData?.contact_person_email}
        labelRoot={classes.labelRoot}
        onChange={(e) => handleInputsChange("contact_person_email", e)}
        onBlur={() => {
          const errors = {};
          if (companyData?.contact_person?.email) {
            errors["email"] = "email should not be empty";
          } else if (!validateEmail(companyData?.contact_person_email)) {
            errors["email"] = "this is not a vailid email";
          }
          setErrors(errors);
          if (Object.keys(errors).length > 0) {
            return;
          }
          updateCompanyDetails("contact_person_email", companyData?.contact_person_email);
        }}
        error={errors.email}
        onFocus={() => setErrors({ ...errors, email: null })}
      />
      <CountryCodePicker
        fullWidth
        name="contact_person_phone"
        type="number"
        labelRoot={classes.labelRoot}
        id="number-input"
        placeHolder="Phone Number"
        value={companyData?.contact_person_phone}
        countryCode={
          companyData?.contact_person_phone_code ? companyData?.contact_person_phone_code : "+1"
        }
        onChange={(e) => handleInputsChange("contact_person_phone", e)}
        onBlur={(name, phone) => updateCompanyDetails(name, phone)}
        error={errors.phone}
        onFocus={() => setErrors({ ...errors, phone: null })}
        setErrors={setErrors}
      />
      <Grid style={{ marginTop: "46px" }}>
        <Typography style={{ marginBottom: "20px", fontSize: 14 }}>Company logo</Typography>
        <Grid className={classes.logoMain}>
          <Grid className={classes.logoContainer}>
            {companyData?.logo ? (
              <Icon src={companyData?.logo} style={{ heigth: "36px", width: "36px" }} />
            ) : (
              <Typography className={classes.logoLabel}>A&R Holdings</Typography>
            )}
          </Grid>
          <Grid style={{ marginLeft: "15px" }}>
            <UploadButton
              accept="image/png, image/jpeg, image/svg, image/gif"
              loading={uploading}
              onChange={uploadImage}
              text="Upload your company logo"
              onlyText
            />
            <Typography>(png/jpg/gif format, 36px height)</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CompanyDetails;
